export default "__VITE_ASSET__cb590350__"